import { createContext } from 'react';

interface HelpCenterContextProps {
  isHelpCenterOpened: boolean;
  setIsHelpCenterOpened: (value: boolean) => void;
  questions: Question[];
  setQuestions: (value: Question[]) => void;
  helpQuestionId: number | null;
  setHelpQuestionId: (value: number | null) => void;
  targetQuestionTitle: string;
  setTargetTargetQuestionTitle: (value: string) => void;
}

const HelpCenterContext = createContext<HelpCenterContextProps>(
  {} as HelpCenterContextProps
);

export default HelpCenterContext;
